import * as React from 'react';

import { getDisplayDateRange } from 'utils/date';

import './deliverable-timeline-view.scss';

type Props = {
  endDate: string,
  startDate: string,
  title: string
}

const DeliverableTimelineView = ({ title, startDate, endDate }: Props) => {
  if (!(startDate || endDate)) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="deliverable-timeline-view__title">
        {title}
      </div>
      <div className="deliverable-timeline-view__date">
        {getDisplayDateRange(startDate, endDate)}
      </div>
    </React.Fragment>
  );
};

export default DeliverableTimelineView;
